if (!customElements.get('shipping-bar')) {
  class ShippingBar extends HTMLElement {
    constructor() {
      super();
    }

    calculateRemainingAmount() {
      this.currentValue = (this.freeShippingAmount - this.cartValue) > 0 ? (this.freeShippingAmount - this.cartValue) / 100 : 0;
    }

    setProgressElementValue() {
      if (!this.progress) return;

      this.progress.value = this.cartValue / 100;
    }

    setText() {
      const format = window.moneyFormat.replace('{{amount}}', this.currentValue).replace('.00', '');
      this.label.innerText = this.label.innerText.replace('[[amount]]', format);
    }

    connectedCallback() {
      this.label = this.querySelector('label');
      this.progress = this.querySelector('progress');

      this.freeShippingAmount = Number(this.getAttribute('data-free-shipping-amount'));
      this.cartValue = Number(this.getAttribute('data-cart-value'));
      this.currencyRate = Number(Shopify.currency.rate);

      this.calculateRemainingAmount();

      this.shippingText = this.getAttribute('data-shipping-text');
      this.freeShippingText = this.getAttribute('data-free-shipping-text');

      this.setProgressElementValue();
      this.setText();
    }
  }

  customElements.define('shipping-bar', ShippingBar);
}
